import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import ServicesGrid from './components/ServicesGrid';
import PortalPreview from './components/PortalPreview';
import SmallClaimsSection from './components/SmallClaimsSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: 'Inter, sans-serif' }}>
      <Navbar />
      <HeroSection />
      <TrustBar />
      <ServicesGrid />
      <PortalPreview />
      <SmallClaimsSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </div>
  );
}
